import { useState, useEffect } from 'react';
import {
  prepareContextMenu,
  GridContextMenuProps,
} from '../../../helpers/contextMenu/prepareContextMenu';
import { useAppDispatch } from '../../../../core/hooks/storeHooks';
import { IContextMenuItem } from '../../../helpers/contextMenu/types';

export default (props: GridContextMenuProps) => {
  const dispatch = useAppDispatch();
  const menus = prepareContextMenu(props, dispatch); // [][]

  const [searchText, setSearchText] = useState('');

  const menuSets = filterMenuItems(menus, searchText);

  // This outside check is needed for SubMenu Sometimes the library @zshsin/react-menu does not call
  // the close menu on outside click if resolved in future remove the event listener and className from MenuAtoms
  const onOutsideMouseDown = (e: MouseEvent) => {
    let el = e.target as Element;
    if (!el.classList.contains('context-menu')) {
      console.log('closing menu');
      document.removeEventListener('mousedown', onOutsideMouseDown);
      props.closeContextMenu();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', onOutsideMouseDown);
    return () => {
      document.removeEventListener('mousedown', onOutsideMouseDown);
    };
  }, []);

  return {
    menuSets,
    searchText,
    setSearchText,
  };
};

// #region filter menu helper
const filterMenuItems = (
  menuItems: IContextMenuItem[][],
  searchText: string
): IContextMenuItem[][] => {
  if (!searchText) return menuItems;

  return menuItems
    .map(
      (menus) =>
        menus
          .map((menuItem) => {
            const hasMatchingTitle = menuItem.title
              .toLowerCase()
              .includes(searchText.trim().toLowerCase());
            const hasMatchingChild = menuItem.nestedMenus
              ? filterMenuItems(menuItem.nestedMenus, searchText).flat()
                  .length > 0
              : false;

            if (hasMatchingTitle || hasMatchingChild) {
              const filteredMenuItem = { ...menuItem };
              if (menuItem.nestedMenus) {
                filteredMenuItem.nestedMenus = filterMenuItems(
                  menuItem.nestedMenus,
                  searchText
                );
              }
              return filteredMenuItem;
            }

            return null;
          })
          .filter((menuItem) => menuItem !== null) as IContextMenuItem[]
    )
    .filter((menus) => menus.length > 0);
};
// #endregion
